exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "navtab .navtab {\n  position: relative;\n  height: 50px;\n  border-bottom: 1px solid #e8eaea; }\n  navtab .navtab .tabs {\n    position: relative;\n    height: 50px; }\n    navtab .navtab .tabs .tab {\n      position: relative;\n      width: auto;\n      margin-top: 10px;\n      height: 40px;\n      line-height: 40px;\n      float: left;\n      font-size: 14px;\n      color: #666666;\n      cursor: pointer;\n      text-align: center;\n      padding: 0 10px; }\n      navtab .navtab .tabs .tab:hover {\n        color: #222222; }\n      navtab .navtab .tabs .tab.active, navtab .navtab .tabs .tab.active:hover {\n        color: #222222;\n        border-bottom: 2px solid #222222; }\n\n@media only screen and (max-width: 767px) {\n  navtab .navtab .tabs {\n    width: auto; }\n  navtab .navtab .tabs .tab {\n    font-size: 14px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/common/navtab/navtab.scss
// module id = 661
// module chunks = 3